// extracted by mini-css-extract-plugin
module.exports = {"Price":"Price_Price__xd5Nb","Price__Montyly":"Price_Price__Montyly__1fQJo","Price__Emphasis":"Price_Price__Emphasis__lzm0k"};